import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core';
import { Agreements } from 'src/app/shared/constants/agreements';
import { map, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { AbstractControl } from '@angular/forms';
import { ValidationService } from 'src/app/shared/services/validation/validation.service';
import { LabPassRepositoryService } from '../../services/lab-pass.repository.service';
import { QuestionsFormService } from './services/questions-form.service';
import { StorageService } from '../../../../shared/core/services/storage.service';
import { LabPassDataSourceService } from '../../services/lab-pass.datasource.service';
import { ErrorMessages } from '../../../../shared/types/error-messages.enum';

@Component({
  selector: 'app-form-questions',
  templateUrl: './form-questions.component.html',
  styleUrls: ['./form-questions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormQuestionsComponent implements OnDestroy {
  constructor(
    private labPassService: LabPassRepositoryService,
    private dataSourceService: LabPassDataSourceService,
    public questionsFormService: QuestionsFormService,
    private storage: StorageService,
    private validationService: ValidationService
  ) {}

  ngUnsubscribe$ = new Subject<void>();

  mainHost$ = this.storage.configuration$.pipe(
    map((config) => config.hosts.main)
  );

  get Agreements(): typeof Agreements {
    return Agreements;
  }

  sendFormRequest(): void {
    const convertedControlsFromGroup = (): Array<AbstractControl> => {
      const { controls } = this.questionsFormService.form;
      return Object.values(controls);
    };

    const validationHasErrors = !this.validationService.validate(
      convertedControlsFromGroup(),
      true
    );

    if (validationHasErrors) return;

    const { email, personalInfo, comment } =
      this.questionsFormService.form.getRawValue();
    const info = {
      name: personalInfo,
      email,
      comment,
    };

    this.questionsFormService.isPending = true;
    this.dataSourceService
      .sendFeedbackPass(info)
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe({
        next: () => {
          this.questionsFormService.isPending = false;

          this.labPassService.openModalSuccess();
          this.questionsFormService.form.reset();
        },
        error: () => {
          this.questionsFormService.isPending = false;

          this.labPassService.openModalError(ErrorMessages.Common);
        },
      });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
